import { env } from './env'

// The dev tools (environment switcher + test users) are an internal, non-production
// aid. In production the app always talks to the baked-in VITE_API_BASE_URL.
export const isDevToolsEnabled = env.VITE_APP_ENV !== 'production'

// localStorage key holding a per-browser override of the API base URL, set when a
// developer picks a review-app environment from the dev tools widget.
const OVERRIDE_KEY = 'dev_api_base_url'

function isLocalStorageAvailable(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const testKey = '__test__'
    window.localStorage.setItem(testKey, testKey)
    window.localStorage.removeItem(testKey)
    return true
  } catch {
    return false
  }
}

// The active API base URL for every request. Outside dev tooling this is just the
// build-time env value; in staging/local it honours the developer's override.
export function getApiBaseUrl(): string {
  if (!isDevToolsEnabled || !isLocalStorageAvailable()) {
    return env.VITE_API_BASE_URL
  }
  return localStorage.getItem(OVERRIDE_KEY) ?? env.VITE_API_BASE_URL
}

export function getApiBaseUrlOverride(): string | null {
  if (!isDevToolsEnabled || !isLocalStorageAvailable()) return null
  return localStorage.getItem(OVERRIDE_KEY)
}

// Passing null clears the override and falls back to the build-time env value.
export function setApiBaseUrlOverride(url: string | null): void {
  if (!isDevToolsEnabled || !isLocalStorageAvailable()) return
  if (url) {
    localStorage.setItem(OVERRIDE_KEY, url)
  } else {
    localStorage.removeItem(OVERRIDE_KEY)
  }
}
